import './index.scss';
import merge from 'lodash/merge';
import React from 'react';
import { IColorConfig } from '../../interface';
import { defaultColorConfig } from '../../dataFlow';
import { BlockColor, Button, ColorPicker, tinyColor } from '@umu/umu-design';
import { If } from 'common/src/components';

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    value: string;
    prefixCls?: string;
    config: IColorConfig;
    onDataChange: (color: string) => void;
}
function ColorSelect(props: IProps) {
    const { config, value, className = '', prefixCls = 'navigation-color-select', onDataChange, ...rest } = props;
    const configColor = merge({}, defaultColorConfig, config);
    return (
        <ColorPicker defaultColor={value} onColorSelect={(val: any) => {
            onDataChange(tinyColor(val.rgb).toHexString());
        }} dropProps={{overlayClassName: `${prefixCls}-color-panel`}}>
            <div className={`${prefixCls} ${className}`} {...rest}>
                <BlockColor color={value} />
                <div className={`${prefixCls}-config-suffix`} onClick={(e) => e.stopPropagation && e.stopPropagation()}>
                    <div className={`${prefixCls}-config-suffix-select-color`}>{value}</div>
                    <If condition={!!configColor.isAllowRest}>
                        <Button
                            type="text"
                            className={`${prefixCls}-config-suffix-split`}
                            isOnlyChildren
                            onClick={() => onDataChange(configColor.restColor || '')}
                        >
                            {configColor.restText}
                        </Button>
                    </If>
                </div>
            </div>
        </ColorPicker>
    );
}

export { ColorSelect };
